<template>
  <div>
    <div v-if="show">
      <formulas-by-resource-dialog
        v-model="formulas"
        :resourceName="value?.name ?? 'N/A'"
        :subTitle="$t('formula.byResource.includedTag')"
        @cancel="cancel"
        @forceRemove="forceRemove"
      />
      <delete-dialog
        :dialog="deleteConfirmDialog"
        v-on:confirm-delete="remove"
        v-on:cancel-dialog="cancel"
      />
    </div>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import DeleteDialog from "@/components/common/DeleteDialog";
import FormulasByResourceDialog from "@/components/formula/FormulasByResourceDialog";

export default {
  name: "DeleteTagDialog",

  components: {
    DeleteDialog,
    FormulasByResourceDialog,
  },

  props: {
    show: {
      type: Boolean,
      default: false,
    },

    value: {
      type: Object,
      default: () => ({}),
    },
  },

  model: {
    prop: "value",
  },

  data() {
    return {
      deleteConfirmDialog: false,
      formulas: [],
    };
  },

  methods: {
    ...mapActions("formulas", ["getFormulasByTag"]),
    ...mapActions("tag", ["deleteTag", "deleteTagForce"]),

    ...mapActions("alert", ["success", "error"]),

    async remove() {
      if (this.value?.deveui == null || this.value?.deveui == undefined) {
        this.error(this.$t("formula.errors.noId"));
        return;
      }

      (await this.deleteTag({
        tagId: this.value.deveui,
      }))
        ? this.success(this.$t("common.deleted"))
        : this.error(this.$t("formula.errors.delete"));

      this.$emit("update");
    },

    async forceRemove() {
      if (this.value?.deveui == null || this.value?.deveui == undefined) {
        this.error(this.$t("formula.errors.noId"));
        return;
      }

      (await this.deleteTagForce(this.value.deveui))
        ? this.success(this.$t("common.deleted"))
        : this.error(this.$t("formula.errors.delete"));

      this.$emit("update");
    },

    cancel() {
      this.$emit("cancel");
    },
  },

  async created() {
    if (this.value?.deveui) {
      this.formulas = await this.getFormulasByTag(this.value.deveui);
      if (this.formulas == undefined)
        this.error(this.$t("formula.errors.gettingData"));
    }
  },

  watch: {
    show: {
      //Determines if the tag is a formula resource to show the relevant delete dialog
      async handler(val) {
        if (val) {
          this.formulas = await this.getFormulasByTag(this.value?.deveui);
          if (this.formulas == undefined)
            this.error(this.$t("formula.errors.gettingData"));

          this.deleteConfirmDialog = this.formulas && this.formulas.length == 0;
        }
      },
    },
  },
};
</script>
